/**
 * Replaces "Deliver every" with "Pay every" in subscription widget text.
 * Handles shadow DOM and retries for late-loading payment/subscription UI.
 */
(function () {
  function replaceText(node) {
    if (node.nodeType === Node.TEXT_NODE && node.textContent.includes('Deliver every')) {
      node.textContent = node.textContent.replace(/Deliver every/g, 'Pay every');
    } else if (node.nodeType === Node.ELEMENT_NODE && !['SCRIPT', 'STYLE'].includes(node.tagName)) {
      if (node.shadowRoot) replaceText(node.shadowRoot);
      node.childNodes.forEach(replaceText);
    }
  }

  function run() {
    if (!document.body) return;
    replaceText(document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  const observer = new MutationObserver(function () {
    run();
  });
  if (document.body) observer.observe(document.body, { childList: true, subtree: true });

  [100, 500, 1500, 3000].forEach(function (ms) {
    setTimeout(run, ms);
  });
})();
